import React, { createContext, useState, useContext } from 'react';

const FilesConfigContext = createContext();

export default function FilesConfigProvider(props) {

    const getInitialState = () => {
        const jsonString = document.getElementById(props.configContainerID).value;
        return JSON.parse(jsonString);
    };

    const updateAspNetInput = (newFilesConfig) => {
        const element = document.getElementById(props.configContainerID);
        const json = JSON.stringify(newFilesConfig);
        element.value = json;
    };

    const initialState = getInitialState();

    const [filesConfig, setFilesConfig] = useState(initialState);

    const saveState = (newFilesConfig, isDirty) => {

        if (isDirty !== undefined) {
            newFilesConfig.IsDirty = isDirty;
            window.dispatchEvent(new CustomEvent('idss.isDirty', {
                detail: {
                    isDirty: isDirty
                }
            }));
        }

        setFilesConfig(newFilesConfig);
        updateAspNetInput(newFilesConfig);
    }

    const addDetail = () => {
        let json = JSON.parse(document.getElementById(props.templateContainerID).value);
        const detailCount = filesConfig.Files.length;

        const newFilesConfig = JSON.parse(JSON.stringify(filesConfig));

        // Allocate a temporary id
        let maxID = Math.max(...filesConfig.Files.map(o => o.AccountFileID), 0);
        let maxSortOrder = Math.max(...filesConfig.Files.map(o => o.SortOrder), 0);
        json.AccountFileID = maxID + 1;
        json.SortOrder = maxSortOrder + 1;

        newFilesConfig.Files.splice(detailCount, 0, json);

        saveState(newFilesConfig, true);
    };

    const updateDetail = (detailID, fieldName, value) => {
        let existingDetail = getDetail(detailID);
        let index = filesConfig.Files.indexOf(existingDetail);

        var newFilesConfig = JSON.parse(JSON.stringify(filesConfig));
        newFilesConfig.Files[index][fieldName] = value;

        saveState(newFilesConfig, true);
    };

    const deleteDetail = (detailID) => {
        updateDetail(detailID, "IsActive", false);
    };

    const restoreDetail = (detailID) => {
        updateDetail(detailID, "IsActive", true);
    };

    const getDetail = (id) => {
        let found = filesConfig.Files.find(f => f.AccountFileID === id);

        return found;
    };

    const setDetailDialogVisible = (show, save) => {
        var newFilesConfig = JSON.parse(JSON.stringify(filesConfig));

        newFilesConfig.DetailDialogVisible = show;

        if (save) {
            // Load the one we are editing
            let existingDetail = getDetail(filesConfig.DetailDialogID);
            let index = filesConfig.Files.indexOf(existingDetail);

            // Copy over the in-progress values
            newFilesConfig.Files[index] = newFilesConfig.EditingDetail;

            // Reset the editor
            newFilesConfig.EditingDetail = null;
            newFilesConfig.DetailDialogID = null;

            saveState(newFilesConfig, true);
        }
        else {
            saveState(newFilesConfig);
        }
    };

    const setDetailDialogID = (value) => {

        var newFilesConfig = JSON.parse(JSON.stringify(filesConfig));

        newFilesConfig.DetailDialogID = value;
        newFilesConfig.DetailDialogVisible = true;

        // Have we changed the cost we're editing?
        if (filesConfig.DetailDialogID !== value) {
            // Make the current cost available for editing
            newFilesConfig.EditingDetail = newFilesConfig.Files.find(f => f.AccountFileID === value);
        }

        saveState(newFilesConfig);
    };

    const updateFileDetail = (detailID, fieldName, value) => {
        var newFilesConfig = JSON.parse(JSON.stringify(filesConfig));
        newFilesConfig.EditingDetail[fieldName] = value;

        saveState(newFilesConfig, true);
    };

    const updateFileTypeDetail = (detailID, value, label) => {
        var newFilesConfig = JSON.parse(JSON.stringify(filesConfig));
        newFilesConfig.EditingDetail.FileType = value;
        newFilesConfig.EditingDetail.FileTypeDisplay = label;

        saveState(newFilesConfig, true);
    };

    const getDetails = () => {
        filesConfig.Files.sort(function (a, b) {
            return a.SortOrder - b.SortOrder;
        })

        return filesConfig.Files;
    }

    // Update the list from the server
    const setFileList = (files) => {
        var newFilesConfig = JSON.parse(JSON.stringify(filesConfig));
        var added = false;

        for (let i = 0; i < files.length; i++) {
            let existingDetail = getDetail(files[i].AccountFileID);
        
            if (existingDetail == null) {
                //console.log('New file added', files[i]);
                newFilesConfig.Files.push(files[i]);
                added = true;
            }
        }

        saveState(newFilesConfig, added);
    }

    const moveFileUp = (id) => {
        var existing = getDetail(id);
        let index = filesConfig.Files.indexOf(existing);

        if (index < 0 || index >= filesConfig.Files.length - 1) return;

        const newFilesConfig = JSON.parse(JSON.stringify(filesConfig));

        // Swap SortOrder with the next item
        let tempSortOrder = newFilesConfig.Files[index].SortOrder;
        newFilesConfig.Files[index].SortOrder = newFilesConfig.Files[index + 1].SortOrder;
        newFilesConfig.Files[index + 1].SortOrder = tempSortOrder;

        // If needed, swap the items to keep the array sorted by SortOrder
        let tempItem = newFilesConfig.Files[index];
        newFilesConfig.Files[index] = newFilesConfig.Files[index + 1];
        newFilesConfig.Files[index + 1] = tempItem;     

        saveState(newFilesConfig, true);
    };

    const moveFileDown = (id) => {
        var existing = getDetail(id);
        let index = filesConfig.Files.indexOf(existing);

        if (index <= 0 || index >= filesConfig.Files.length) return;

        const newFilesConfig = JSON.parse(JSON.stringify(filesConfig));

        // Swap SortOrder with the next item
        let tempSortOrder = newFilesConfig.Files[index].SortOrder;
        newFilesConfig.Files[index].SortOrder = newFilesConfig.Files[index - 1].SortOrder;
        newFilesConfig.Files[index - 1].SortOrder = tempSortOrder;

        // If needed, swap the items to keep the array sorted by SortOrder
        let tempItem = newFilesConfig.Files[index];
        newFilesConfig.Files[index] = newFilesConfig.Files[index - 1];
        newFilesConfig.Files[index - 1] = tempItem;     

        saveState(newFilesConfig, true);
    };

    return (
        <FilesConfigContext.Provider value={{
            filesConfig,
            getDetail, getDetails,
            addDetail, updateDetail, deleteDetail, restoreDetail,
            setDetailDialogVisible, setDetailDialogID,
            updateFileDetail, updateFileTypeDetail,
            setFileList, moveFileUp, moveFileDown
        }}>
            {props.children}
        </FilesConfigContext.Provider>
    );
}

export const useFilesConfig = () => useContext(FilesConfigContext);